var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.425 20.9626L17.875 16.4126C18.9313 15.0313 19.5813 13.3251 19.5813 11.4563C19.5813 6.98755 15.925 3.3313 11.4563 3.3313C6.9875 3.3313 3.25 6.98755 3.25 11.4563C3.25 15.9251 6.90625 19.5813 11.375 19.5813C13.2438 19.5813 15.0313 18.9313 16.4125 17.7938L20.9625 22.3438C21.125 22.5063 21.45 22.6688 21.6938 22.6688C21.9375 22.6688 22.1813 22.5876 22.425 22.3438C22.8313 22.0188 22.8313 21.3688 22.425 20.9626ZM5.28125 11.4563C5.28125 8.12505 8.04375 5.36255 11.375 5.36255C14.7063 5.36255 17.4688 8.12505 17.4688 11.4563C17.4688 14.7875 14.7063 17.5501 11.375 17.5501C8.04375 17.5501 5.28125 14.8688 5.28125 11.4563Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.e2c49def1acf43a5f06e642725a4ee37.svg";
export { ForwardRef as ReactComponent };